import { render } from "./activities-scr.vue?vue&type=template&id=7805de8a&scoped=true"
import script from "./activities-scr.vue?vue&type=script&lang=js"
export * from "./activities-scr.vue?vue&type=script&lang=js"

import "./activities-scr.vue?vue&type=style&index=0&id=7805de8a&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7805de8a"]])

export default __exports__